import 'waypoints/lib/jquery.waypoints.min';

var classes = {
    pngSplitComponent: "png-split-section",
    pngSplitImgRight: "png-split-section__image",
    pngSplitImgLeft: "png-split-section__image--order",
    pngSplitContent: "png-split-section__content"
};

var animations = {
    animateFromLeft: "visible animated fadeInRightBig slow",
    animateFromRight: "visible animated fadeInLeftBig slow",
    animateContent: "visible animated fadeIn slow"
};

var addWaypoints = function() {
    //set a waypoint for all the sections on the page
    var pngSplitWaypoint = $('.' + classes.pngSplitComponent).waypoint(function(direction) {
        //check the direction
        if (direction === 'down') {
            //add the class(es) to start the animation
            $(this.element).find('.' + classes.pngSplitImgRight + ' img').addClass(animations.animateFromRight);
            $(this.element).find('.' + classes.pngSplitImgLeft + ' img').addClass(animations.animateFromLeft);
            $(this.element).find('.' + classes.pngSplitContent).addClass(animations.animateContent);
            //then destroy this waypoint, we don't need it anymore
            this.destroy();
        }
        pngSplitWaypoint;
    }, {
        offset: '55%'
    });
};

var init = function() {
    //in experience editor don't add waypoints
    if ($('.is-experience-editor').length) return;
    //else
    addWaypoints();
};

$(document).ready(function() {
    if ($('.' + classes.pngSplitComponent).length) {
        init();
    }
});
